<template>
  <div class='main'>
    <nav-top></nav-top>
    <el-row type="flex" justify="center">
      <el-col :span="17" class="seat_content">
        <el-row class="seat_cc">
          <el-col :span="20" class="seat_crumbs">
            您的位置：
            <a href="http://www.jssyyjxh.com">江苏省音乐家协会</a> > 选座位
          </el-col>
            <el-col :span="4" class="seat_crumbs">
           <div class="goback_info"  @click="()=>{this.$router.go(-1)}">返回</div>
          </el-col>
        </el-row>
        <el-row>
            <el-col style='padding-left:10px;'>
                <seat-vue></seat-vue>
            </el-col>
        </el-row>
      </el-col>
    </el-row>
    <div class="box_footer">
      <p style="padding:10px 0;">省音协考级报名咨询电话 025-83572077</p>
      <p>苏ICP备：10064548号</p>
    </div>
  </div>
</template>
<script>
import navTop from "@/components/navTop";
import seatVue from "@/components/seat.vue";
export default {
  components: {
    navTop,
    seatVue
  },
  data() {
    return {

    };
  },
  created(){
    //  window.Global.checkToken()
  },
  methods: {
  }
};
</script>
<style lang="less">
.seat_content {
  background: #fff;
  border: 1px solid #cbc6c0;
  border-top: 0;
  padding: 20px 15px;
  .seat_cc {
    .seat_crumbs {
      font-size: 12px;
      height: 40px;
      a {
        color: #666;
      }
    }
  }
}
.goback_info{
 background:#EEEAE7;
  width: 50%;
  margin: 0 auto;
  text-align: center;
  font-size: 14px;
  line-height: 30px;
  color:#9E7536;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/indexSeat.vue